import {
  AmpClient,
  AmpRegistrationStatus,
} from "@redotech/redo-model/amp-registration-definition";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";

export const sendDemoAmpEmailsForTeam = {
  name: "sendDemoAmpEmailsForTeam" as const,
  input: z.object({
    teamId: z.string(),
    senderAddress: z.object({ localPart: z.string(), domain: z.string() }),
  }),
  output: z.object({
    [AmpClient.GMAIL]: z.union([
      createEnum(AmpRegistrationStatus),
      z.undefined(),
    ]),
    [AmpClient.YAHOO]: z.union([
      createEnum(AmpRegistrationStatus),
      z.undefined(),
    ]),
  }),
};
